// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2lNTG","subheader":"ReorderModal_subheader__3IhJy","listWrap":"ReorderModal_listWrap__31lRn"};